module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('meta', {
    attrs: {
      "charset": "utf-8"
    }
  }), _vm._v(" "), (_vm.isDetailApi) ? _c('div', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "id": "apierror"
    }
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary",
    attrs: {
      "id": "Diagnose"
    },
    on: {
      "click": function($event) {
        return _vm.diagnose()
      }
    }
  }, [_vm._v("⛨ Diagnose")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, _vm._l((_vm.badRunners), function(id) {
    return _c('li', {
      staticStyle: {
        "display": "block"
      }
    }, [_c('div', {
      staticClass: "chip"
    }, [_vm._v("\n          " + _vm._s(id) + "\n\n          "), _c('button', {
      on: {
        "click": function($event) {
          return _vm.removeRunner(id)
        }
      }
    }, [_vm._v("✕")])])])
  }), 0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex btnContainer"
  }, [_c('div', {
    staticStyle: {
      "width": "92%"
    }
  }, [(_vm.notStarted) ? _c('button', {
    staticClass: "btn leftbtn loadRunnersBtn roundBtn",
    attrs: {
      "id": "loaddata",
      "disabled": _vm.loadingRunners
    },
    on: {
      "click": function($event) {
        return _vm.loaddata()
      }
    }
  }, [_vm._v("\n        Load Runners\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.notStarted && !_vm.isFreeze && _vm.status != 'finished') ? _c('button', {
    staticClass: "btn leftbtn freezeBtn roundBtn",
    on: {
      "click": function($event) {
        return _vm.freeze()
      }
    }
  }, [_vm._v("\n        Freeze\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.notStarted && _vm.isFreeze && _vm.status != 'finished') ? _c('button', {
    staticClass: "btn leftbtn unfreezeBtn roundBtn",
    on: {
      "click": function($event) {
        return _vm.unfreeze()
      }
    }
  }, [_vm._v("\n        Unfreeze\n      ")]) : _vm._e(), _vm._v(" "), (_vm.tableData) ? _c('button', {
    staticClass: "btn btn--primary load_data",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "id": "downloadcsv",
      "disabled": _vm.isExportAsCsv || _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.loadDataForExportCsv()
      }
    }
  }, [_vm._v("Export as CSV\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "8%",
      "display": "flex",
      "justify-content": "flex-end",
      "align-items": "center",
      "position": "relative"
    }
  }, [_c('toggle-button', {
    attrs: {
      "id": "changed-font",
      "width": 85,
      "height": 30,
      "speed": 480,
      "color": {
        unchecked: '#413b94',
        checked: '#ff5627'
      },
      "labels": {
        checked: 'Km',
        unchecked: 'Miles'
      }
    },
    on: {
      "change": function($event) {
        return _vm.onToggle()
      }
    },
    model: {
      value: (_vm.distanceInKm),
      callback: function($$v) {
        _vm.distanceInKm = $$v
      },
      expression: "distanceInKm"
    }
  }), _vm._v(" "), (_vm.status === 'finished' && _vm.currentRaceStatus === 'finished') ? _c('button', {
    staticClass: "three-dots-btn",
    staticStyle: {
      "background": "none",
      "border": "none",
      "font-size": "24px",
      "cursor": "pointer",
      "padding": "0 10px",
      "margin-left": "5px",
      "line-height": "1",
      "color": "#555",
      "outline": "none"
    },
    on: {
      "click": function($event) {
        _vm.showMonitoringMenu = !_vm.showMonitoringMenu
      }
    }
  }, [_vm._v("\n        ⋮\n      ")]) : _vm._e(), _vm._v(" "), (_vm.showMonitoringMenu && _vm.status === 'finished' && _vm.currentRaceStatus === 'finished') ? _c('div', {
    staticClass: "dropdown-menu-content",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "100%",
      "margin-top": "5px",
      "background": "white",
      "border": "1px solid #ebebeb",
      "box-shadow": "0 4px 12px rgba(0,0,0,0.1)",
      "z-index": "1000",
      "border-radius": "4px",
      "min-width": "200px",
      "white-space": "nowrap",
      "overflow": "hidden"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "width": "100%",
      "text-align": "left",
      "padding": "12px 16px",
      "border": "none",
      "background": "white",
      "color": "#333",
      "cursor": "pointer",
      "font-size": "13px",
      "outline": "none",
      "border-bottom": "1px solid #f9f9f9"
    },
    attrs: {
      "title": "Stop continuous monitoring after race is finished",
      "onmouseover": "this.style.backgroundColor='#f5f5f5'",
      "onmouseout": "this.style.backgroundColor='white'"
    },
    on: {
      "click": function($event) {
        _vm.stopMonitoring();
        _vm.showMonitoringMenu = false
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "margin-right": "8px",
      "width": "16px",
      "text-align": "center",
      "color": "#666"
    }
  }, [_vm._v("◻")]), _vm._v(" Stop Monitoring\n        ")]), _vm._v(" "), (!_vm.continueMonitoring) ? _c('button', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "width": "100%",
      "text-align": "left",
      "padding": "12px 16px",
      "border": "none",
      "background": "white",
      "color": "#333",
      "cursor": "pointer",
      "font-size": "13px",
      "outline": "none"
    },
    attrs: {
      "title": "Resume continuous monitoring after race is finished",
      "onmouseover": "this.style.backgroundColor='#f5f5f5'",
      "onmouseout": "this.style.backgroundColor='white'"
    },
    on: {
      "click": function($event) {
        _vm.resumeMonitoring();
        _vm.showMonitoringMenu = false
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "margin-right": "8px",
      "width": "16px",
      "text-align": "center",
      "color": "#666"
    }
  }, [_vm._v("▷")]), _vm._v(" Resume Monitoring\n        ")]) : _vm._e()]) : _vm._e()], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), (!this.$props.isPastRun) ? _c('div', {
    staticClass: "runner-table",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('v-table', {
    staticStyle: {
      "width": "100%",
      "font-size": "10.5px"
    },
    attrs: {
      "is-horizontal-resize": "",
      "is-loading": _vm.loading,
      "columns": _vm.columns,
      "column-cell-class-name": _vm.columnCellClass,
      "table-data": _vm.tableData,
      "show-vertical-border": true,
      "odd-bg-color": '#cfe2f3',
      "title-row-height": 60,
      "row-height": 45,
      "border": 1,
      "filter-method": _vm.filterMethod
    },
    on: {
      "on-custom-comp": _vm.customCompFunc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager_btns"
  }, [_c('runner-pagination', {
    attrs: {
      "total": _vm.totalItems,
      "totalJoinedRunner": _vm.totalJoinedRunner,
      "currentPageIndex": _vm.pageIndex,
      "disableDefaultStyles": true,
      "isFilterOn": _vm.filterRunner
    },
    on: {
      "changePage": _vm.onChangePage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "filter-btn"
  }, [_c('button', {
    staticClass: "totalPaceBtn",
    attrs: {
      "disabled": _vm.filterRunner && !_vm.filterTotalPace,
      "title": "Filter runners with total pace above 90% of their target pace. Useful for identifying high-performing runners."
    },
    on: {
      "click": function($event) {
        return _vm.filterRunnerData('totalPace')
      }
    }
  }, [_vm._v("Total Pace\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "totalRunBtn",
    attrs: {
      "disabled": _vm.filterRunner && !_vm.filterTotalRuns,
      "title": "Filter runners based on their total number of completed runs. Helps track participation frequency."
    },
    on: {
      "click": function($event) {
        return _vm.filterRunnerData('totalRuns')
      }
    }
  }, [_vm._v("# Of Run\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "totalDistanceBtn",
    attrs: {
      "disabled": _vm.filterRunner && !_vm.filterTotalDistance,
      "title": "Filter runners based on their total distance covered. Useful for tracking overall distance achievements."
    },
    on: {
      "click": function($event) {
        return _vm.filterRunnerData('totalDistance')
      }
    }
  }, [_vm._v("Total KM\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "ekidenBtn",
    attrs: {
      "disabled": _vm.filterRunner && !_vm.filterEkiden,
      "title": "Filter runners participating in Ekiden relay races. Shows team-based race participants."
    },
    on: {
      "click": function($event) {
        return _vm.filterRunnerData('Ekiden')
      }
    }
  }, [_vm._v("\n          Ekiden\n        ")])])], 1), _vm._v(" "), _c('lucky-live-runner', {
    attrs: {
      "details": _vm.detail,
      "show": _vm.showModal
    },
    on: {
      "saved": _vm.onSaved,
      "closed": _vm.onClosed
    }
  }), _vm._v(" "), _c('bonus-distance-modal', {
    attrs: {
      "details": _vm.detail,
      "show": _vm.showBonusModal
    },
    on: {
      "saved": _vm.onSaved,
      "closed": _vm.onClosed
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.$props.isPastRun) ? _c('div', {
    staticClass: "runner-table",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('v-table', {
    staticStyle: {
      "width": "100%",
      "font-size": "10.5px"
    },
    attrs: {
      "is-horizontal-resize": "",
      "columns": _vm.columns,
      "column-cell-class-name": _vm.columnCellClass,
      "table-data": _vm.tableData,
      "show-vertical-border": true,
      "odd-bg-color": '#cfe2f3',
      "title-row-height": 60,
      "border": 1,
      "row-height": 45,
      "filter-method": _vm.filterMethod,
      "is-loading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager_btns"
  }, [_c('runner-pagination', {
    attrs: {
      "total": _vm.totalItems,
      "totalJoinedRunner": _vm.totalJoinedRunner,
      "currentPageIndex": _vm.pageIndex,
      "disableDefaultStyles": true
    },
    on: {
      "changePage": _vm.onChangePage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "filter-btn"
  }, [_c('button', {
    staticClass: "totalPaceBtn",
    attrs: {
      "disabled": _vm.filterRunner && !_vm.filterTotalPace
    },
    on: {
      "click": function($event) {
        return _vm.filterRunnerData('totalPace')
      }
    }
  }, [_vm._v("Total Pace\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "totalRunBtn",
    attrs: {
      "disabled": _vm.filterRunner && !_vm.filterTotalRuns
    },
    on: {
      "click": function($event) {
        return _vm.filterRunnerData('totalRuns')
      }
    }
  }, [_vm._v("# Of Run\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "totalDistanceBtn",
    attrs: {
      "disabled": _vm.filterRunner && !_vm.filterTotalDistance
    },
    on: {
      "click": function($event) {
        return _vm.filterRunnerData('totalDistance')
      }
    }
  }, [_vm._v("Total KM\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "ekidenBtn",
    attrs: {
      "disabled": _vm.filterRunner && !_vm.filterEkiden
    },
    on: {
      "click": function($event) {
        return _vm.filterRunnerData('Ekiden')
      }
    }
  }, [_vm._v("\n          Ekiden\n        ")])])], 1)], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "red",
      "font-size": "13px",
      "text-align": "right"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("⚠")]), _vm._v(" API Issue\n      Getting Runner Details")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "font-size": "large"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "704.688px",
      "overflow-x": "scroll",
      "overflow-y": "hidden"
    },
    attrs: {
      "id": "top-scroll",
      "hidden": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "1542px",
      "height": "5px"
    },
    attrs: {
      "id": "scroll-inner"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89720a58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/RunnersTable.vue
// module id = 1742
// module chunks = 2